import { render } from "./soft-phone-button.vue?vue&type=template&id=4da3b2ae"
import script from "./soft-phone-button.vue?vue&type=script&lang=js"
export * from "./soft-phone-button.vue?vue&type=script&lang=js"

import "./soft-phone-button.vue?vue&type=style&index=0&id=4da3b2ae&lang=css"

import exportComponent from "/Users/garay/code/omnichannel/dashboard-agente/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__